import styled from "styled-components";
import { colors } from "../../consts";
import { Paragraph2, WrapperContainer } from "../../components";

export const LastSegmentedDateInfo = styled(Paragraph2)`
  color: ${colors.RAISIN_80};
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;

  min-width: fit-content;
`;

export const Header = styled(WrapperContainer)`
  position: sticky;
  z-index: 1;
  top: 0;
  background: ${colors.ISABELLINE};
  padding-top: 32px;
`;

export const Controls = styled(WrapperContainer)`
  position: sticky;
  z-index: 1;
  top: 64px;

  padding-top: 24px;

  background: ${colors.ISABELLINE};
`;
